import React from 'react';
import { IconType } from '~/utils';
import { BulletIcon } from '@applyboard/ui-icons';
import { Flex, Heading, Tag, TagProps } from '@applyboard/crystal-ui';
import { ExpandableCard } from '~/components/uie-fix/ExpandableCard';
import { useApplicationCard, CardSection, useAppProcessing } from '../../context';

type CardProps = {
  id: CardSection;
  icon: IconType;
  title: string;
  children: React.ReactNode;
  hideChevron?: boolean;
  tag?: {
    text: string;
    intent: TagProps['intent'];
  };
};

export function Card(props: CardProps) {
  const { application } = useAppProcessing();
  const { isExpanded, toggle } = useApplicationCard(props.id);
  const isChanged = application.meta.changeSet?.includes(props.id);

  return (
    <ExpandableCard
      id={props.id}
      icon={props.icon}
      hideChevron={props.hideChevron}
      title={
        <Flex align="center" justify="between" gap={2}>
          <Flex align="center" gap={2}>
            <Heading level={3}>{props.title}</Heading>
            {isChanged && <BulletIcon intent="warning" variant="fill" />}
          </Flex>
          {props.tag && (
            <Tag intent={props.tag.intent} size="md">
              {props.tag.text}
            </Tag>
          )}
        </Flex>
      }
      isExpanded={isExpanded}
      onIsExpandedChange={(expanded) => toggle(expanded)}
    >
      {props.children}
    </ExpandableCard>
  );
}
